<template>
  <div>
    <div>
      <label v-if="label">{{ label }}</label>
      $
      <input
        ref="input"
        v-bind:value="value"
        v-on:input="updateValue($event.target.value)"
        v-on:focus="formatInput"
        v-on:blur="formatValue"
      >
      <input
        ref="displayInput"
        v-bind:value="value"

      >
    </div>
  </div>
</template>

<script>
  // import 'currency-validator'
  // import '@/../static/library/currencyvalidator.js'
  export default {
    props: {
      value: {
        type: Number,
        default: 0
      },
      label: {
        type: String,
        default: ''
      }
    },
    mounted: function () {
      this.formatValue()
    },
    methods: {
      updateValue: function (value) {
        var result = this.parse(value, this.value)
        if (result.warning) {
          this.$refs.input.value = result.value
        }
        this.$emit('input', result.value)
      },
      formatValue: function () {
        // this.$refs.input.value = this.format(this.value) + '$$$'
        this.$refs.displayInput.value = this.format(this.value) + '$$$'
      },
      formatInput: function (event) {
        this.$refs.displayInput.value = this.format(this.value)
        return event
        // setTimeout(function () {
        //   event.target.select()
        // }, 0)
      },
      format: function (number) {
        return (Math.trunc(number * 100) / 100).toFixed(2)
      },
      parse: function (newString, oldNumber) {
        var CleanParse = function (value) {
          return { value: value }
        }
        var CurrencyWarning = function (warning, value) {
          return {
            warning: warning,
            value: value,
            attempt: newString
          }
        }
        var NotAValidDollarAmountWarning = function (value) {
          return new CurrencyWarning(newString + ' is not a valid dollar amount', value)
        }
        var AutomaticConversionWarning = function (value) {
          return new CurrencyWarning(newString + ' was automatically converted to ' + value, value)
        }
        var newNumber = Number(newString)
        var indexOfDot = newString.indexOf('.')
        var indexOfE = newString.indexOf('e')
        if (isNaN(newNumber)) {
          if (
            indexOfDot === -1 &&
            indexOfE > 0 &&
            indexOfE === newString.length - 1 &&
            Number(newString.slice(0, indexOfE)) !== 0
          ) {
            return new CleanParse(oldNumber)
          } else {
            return new NotAValidDollarAmountWarning(oldNumber)
          }
        }
        var newCurrencyString = this.format(newNumber)
        var newCurrencyNumber = Number(newCurrencyString)
        if (newCurrencyNumber === newNumber) {
          if (indexOfE !== -1 && indexOfE === newString.length - 2) {
            return new AutomaticConversionWarning(newNumber)
          } else {
            return new CleanParse(newNumber)
          }
        } else {
          return new NotAValidDollarAmountWarning(
            newNumber > newCurrencyNumber
              ? newCurrencyNumber
              : oldNumber
          )
        }
      }
    }
  }
</script>

<style scoped>

</style>